import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";

const CourseFacts = () => {

    const coursesBenefit = [
        "Mentor Expert",
        "Materi terstruktur & Up To Date",
        "Investasi Terjangkau",
        "Sertifikat Diakui Regulatory",
        "Pilihan Materi Beragam",
        "Grup Belajar & Lowongan Kerja",
        "Akses Materi & Video Selamanya",
    ];


    return (<>
        <div className="py-3">
            <div className="container">
                <div className="row">
                    <div className="col-md-5 d-flex align-items-center order-2 order-lg-1">
                        <div>
                            <h4 className="fw-bold my-4 text-primary">
                                Video E-Course <br />Program
                            </h4>

                            <p className="fw-medium mb-2" style={{ fontSize: '18px', color: '#1E344C' }}>
                                Belajar Flexible Berbagai Materi Praktisi dari
                                Mentor Expert Terpercaya untuk Upgrade Skill.
                                Akses Materi Dimana dan Kapan Saja Selamanya!
                            </p>

                            {coursesBenefit.map((text, index) => (
                                <p key={index} className="d-flex align-items-center justify-content-start mb-0">
                                    <img src="/assets/icon/check-primary.png" alt="check" className="me-2 mt-1" />

                                    <span className="fw-medium" style={{ fontSize: '18px', color: '#1E344C' }}>{text}</span>
                                </p>
                            ))}

                            <Link to={all_routes.jadiCourse} className="btn btn-yellow mt-4">
                                <span className="fw-bold" style={{ color: '#1E344C', fontSize: '18px' }}>Tonton Sekarang</span>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-7 order-1 order-lg-2">
                        <div className="p-5">
                            <img src="/assets/img/testimonial/course.webp" className="img-fluid" alt="Course" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default CourseFacts;